import 'tiny-slider/dist/tiny-slider.css';
import '../../helpers/slider.less';
import './slider';

// trim-below
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {range} from 'lodash';
import block from 'bem-cn-lite';

const b = block('slider');

class Slider extends Component {
	render() {
		const {count, placeholders, className, mode, autoplay, items, gutter} = this.props;

		const modifiers = {};

		if (className) {
			modifiers[className] = true;
		}

		return (
			<div className={b(modifiers)}
				data-mode={mode}
				data-autoplay={autoplay}
				data-items={items}
				data-gutter={gutter}
			>
				<div className={b('placeholder')}>
					{
						range(count)
							.map(i => (
								<div key={i} className={b('slide')}>
									{placeholders.length > i && !!placeholders[i] ? placeholders[i] : '*** Empty placeholder ***'}
								</div>
							))
					}
				</div>
				<div className={b('controls')}>
					<span className={b('prev')}>
						<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 22 22" className={b('icon')}>
							<path d="M18,2.6L15.3,0L4,11l11.3,11l2.7-2.6L9.3,11L18,2.6z" />
						</svg>
					</span>
					<span className={b('next')}>
						<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 22 22" className={b('icon')}>
							<path d="M12.7,11L4,19.4L6.7,22L18,11L6.7,0L4,2.6L12.7,11z" />
						</svg>
					</span>
				</div>
				{/* <div className={b('nav')}>
					{
						range(count)
							.map(i => (
								<span key={i} className={b('dot')} />
							))
					}
					<span className={b('stop')}>stop</span>
				</div> */}
			</div>
		);
	}
}

Slider.propTypes = {
	count: PropTypes.number.isRequired,
	placeholders: PropTypes.array.isRequired,
	className: PropTypes.string,
	mode: PropTypes.oneOf(['gallery', 'carousel']),
	autoplay: PropTypes.bool,
	items: PropTypes.number,
	gutter: PropTypes.number
};

export default Slider;



// WEBPACK FOOTER //
// ./src/components/slider/index.jsx